import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";


export class MaterialContent {
  
  
  constructor (breakpointObserver: BreakpointObserver, materialV2: boolean = false) {
    
  }
  
}